// @ts-ignore
import soundDefault from '../../assets/audio/scanSound/default.mp3';
// @ts-ignore
import sound7310ca90 from '../../assets/audio/scanSound/7310ca90.mp3';
// @ts-ignore
import sound5e9b920d from '../../assets/audio/scanSound/5e9b920d.mp3';
// @ts-ignore
import soundd6237370 from '../../assets/audio/scanSound/d6237370.mp3';
// @ts-ignore
import sounde886a595 from '../../assets/audio/scanSound/e886a595.mp3';
// @ts-ignore
import soundab6f8dbf from '../../assets/audio/scanSound/ab6f8dbf.mp3';
// @ts-ignore
import soundb3c64911 from '../../assets/audio/scanSound/b3c64911.mp3';
// @ts-ignore
import sounda01d3be0 from '../../assets/audio/scanSound/a01d3be0.mp3';
// @ts-ignore
import soundbe46aef3 from '../../assets/audio/scanSound/be46aef3.mp3';
// @ts-ignore
import sound74bbf67e from '../../assets/audio/scanSound/74bbf67e.mp3';
// @ts-ignore
import sound79e2409c from '../../assets/audio/scanSound/79e2409c.mp3';
// @ts-ignore
import soundc5a7a0b9 from '../../assets/audio/scanSound/c5a7a0b9.mp3';
// @ts-ignore
import sound53d52e4b from '../../assets/audio/scanSound/53d52e4b.mp3';
// @ts-ignore
import sound01304e00 from '../../assets/audio/scanSound/01304e00.mp3';
// @ts-ignore
import sound1444372b from '../../assets/audio/scanSound/1444372b.mp3';
// @ts-ignore
import soundee3cc87d from '../../assets/audio/scanSound/ee3cc87d.mp3';
// @ts-ignore
import soundd574513b from '../../assets/audio/scanSound/d574513b.mp3';
// @ts-ignore
import sound77aa6936 from '../../assets/audio/scanSound/77aa6936.mp3';
// @ts-ignore
import soundf31187ed from '../../assets/audio/scanSound/f31187ed.mp3';
// @ts-ignore
import sound9435a707 from '../../assets/audio/scanSound/9435a707.mp3';

// id 是 localStorage 持久化的 key，与后端 pda_scan_sound_file.sound_id 严格一致，禁止变更
export const SCAN_SOUND_OPTIONS = [
  { id: 'default', labelKey: 'pda.scanSound.options.default', src: soundDefault },
  { id: '7310ca90', labelKey: 'pda.scanSound.options.7310ca90', src: sound7310ca90 },
  { id: '5e9b920d', labelKey: 'pda.scanSound.options.5e9b920d', src: sound5e9b920d },
  { id: 'd6237370', labelKey: 'pda.scanSound.options.d6237370', src: soundd6237370 },
  { id: 'e886a595', labelKey: 'pda.scanSound.options.e886a595', src: sounde886a595 },
  { id: 'ab6f8dbf', labelKey: 'pda.scanSound.options.ab6f8dbf', src: soundab6f8dbf },
  { id: 'b3c64911', labelKey: 'pda.scanSound.options.b3c64911', src: soundb3c64911 },
  { id: 'a01d3be0', labelKey: 'pda.scanSound.options.a01d3be0', src: sounda01d3be0 },
  { id: 'be46aef3', labelKey: 'pda.scanSound.options.be46aef3', src: soundbe46aef3 },
  { id: '74bbf67e', labelKey: 'pda.scanSound.options.74bbf67e', src: sound74bbf67e },
  { id: '79e2409c', labelKey: 'pda.scanSound.options.79e2409c', src: sound79e2409c },
  { id: 'c5a7a0b9', labelKey: 'pda.scanSound.options.c5a7a0b9', src: soundc5a7a0b9 },
  { id: '53d52e4b', labelKey: 'pda.scanSound.options.53d52e4b', src: sound53d52e4b },
  { id: '01304e00', labelKey: 'pda.scanSound.options.01304e00', src: sound01304e00 },
  { id: '1444372b', labelKey: 'pda.scanSound.options.1444372b', src: sound1444372b },
  { id: 'ee3cc87d', labelKey: 'pda.scanSound.options.ee3cc87d', src: soundee3cc87d },
  { id: 'd574513b', labelKey: 'pda.scanSound.options.d574513b', src: soundd574513b },
  { id: '77aa6936', labelKey: 'pda.scanSound.options.77aa6936', src: sound77aa6936 },
  { id: 'f31187ed', labelKey: 'pda.scanSound.options.f31187ed', src: soundf31187ed },
  { id: '9435a707', labelKey: 'pda.scanSound.options.9435a707', src: sound9435a707 },
] as const;

export const DEFAULT_SCAN_SOUND_ID = 'default';
